//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: 'à³§',
            2: 'à³¨',
            3: 'à³©',
            4: 'à³ª',
            5: 'à³«',
            6: 'à³¬',
            7: 'à³­',
            8: 'à³®',
            9: 'à³¯',
            0: 'à³¦',
        },
        numberMap = {
            'à³§': '1',
            'à³¨': '2',
            'à³©': '3',
            'à³ª': '4',
            'à³«': '5',
            'à³¬': '6',
            'à³­': '7',
            'à³®': '8',
            'à³¯': '9',
            'à³¦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'à²à²¨à²µà²°à²¿_à²«à³à²¬à³à²°à²µà²°à²¿_à²®à²¾à²°à³à²à³_à²à²ªà³à²°à²¿à²²à³_à²®à³à³_à²à³à²¨à³_à²à³à²²à³à³_à²à²à²¸à³à²à³_à²¸à³à²ªà³à²à³à²à²¬à²°à³_à²à²à³à²à³à³à³à²¬à²°à³_à²¨à²µà³à²à²¬à²°à³_à²¡à²¿à²¸à³à²à²¬à²°à³'.split(
            '_'
        ),
        monthsShort:
            'à²à²¨_à²«à³à²¬à³à²°_à²®à²¾à²°à³à²à³_à²à²ªà³à²°à²¿à²²à³_à²®à³à³_à²à³à²¨à³_à²à³à²²à³à³_à²à²à²¸à³à²à³_à²¸à³à²ªà³à²à³à²_à²à²à³à²à³à³à³_à²¨à²µà³à²_à²¡à²¿à²¸à³à²'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'à²­à²¾à²¨à³à²µà²¾à²°_à²¸à³à³à³à²®à²µà²¾à²°_à²®à²à²à²³à²µà²¾à²°_à²¬à³à²§à²µà²¾à²°_à²à³à²°à³à²µà²¾à²°_à²¶à³à²à³à²°à²µà²¾à²°_à²¶à²¨à²¿à²µà²¾à²°'.split(
            '_'
        ),
        weekdaysShort: 'à²­à²¾à²¨à³_à²¸à³à³à³à²®_à²®à²à²à²³_à²¬à³à²§_à²à³à²°à³_à²¶à³à²à³à²°_à²¶à²¨à²¿'.split('_'),
        weekdaysMin: 'à²­à²¾_à²¸à³à³à³_à²®à²_à²¬à³_à²à³_à²¶à³_à²¶'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[à²à²à²¦à³] LT',
            nextDay: '[à²¨à²¾à²³à³] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[à²¨à²¿à²¨à³à²¨à³] LT',
            lastWeek: '[à²à³à³à²¨à³à²¯] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s à²¨à²à²¤à²°',
            past: '%s à²¹à²¿à²à²¦à³',
            s: 'à²à³à²²à²µà³ à²à³à²·à²£à²à²³à³',
            ss: '%d à²¸à³à²à³à²à²¡à³à²à²³à³',
            m: 'à²à²à²¦à³ à²¨à²¿à²®à²¿à²·',
            mm: '%d à²¨à²¿à²®à²¿à²·',
            h: 'à²à²à²¦à³ à²à²à²à³',
            hh: '%d à²à²à²à³',
            d: 'à²à²à²¦à³ à²¦à²¿à²¨',
            dd: '%d à²¦à²¿à²¨',
            M: 'à²à²à²¦à³ à²¤à²¿à²à²à²³à³',
            MM: '%d à²¤à²¿à²à²à²³à³',
            y: 'à²à²à²¦à³ à²µà²°à³à²·',
            yy: '%d à²µà²°à³à²·',
        },
        preparse: function (string) {
            return string.replace(/[à³§à³¨à³©à³ªà³«à³¬à³­à³®à³¯à³¦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /à²°à²¾à²¤à³à²°à²¿|à²¬à³à²³à²¿à²à³à²à³|à²®à²§à³à²¯à²¾à²¹à³à²¨|à²¸à²à²à³/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'à²°à²¾à²¤à³à²°à²¿') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'à²¬à³à²³à²¿à²à³à²à³') {
                return hour;
            } else if (meridiem === 'à²®à²§à³à²¯à²¾à²¹à³à²¨') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'à²¸à²à²à³') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'à²°à²¾à²¤à³à²°à²¿';
            } else if (hour < 10) {
                return 'à²¬à³à²³à²¿à²à³à²à³';
            } else if (hour < 17) {
                return 'à²®à²§à³à²¯à²¾à²¹à³à²¨';
            } else if (hour < 20) {
                return 'à²¸à²à²à³';
            } else {
                return 'à²°à²¾à²¤à³à²°à²¿';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(à²¨à³à³)/,
        ordinal: function (number) {
            return number + 'à²¨à³à³';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));
